import React from 'react';

import { Text } from '@atlaskit/primitives';

import { useIntl } from 'src/hooks/intl';
import { PullRequest } from 'src/types/pull-requests-table';

import { PrCycleMetrics } from './api/requests';
import { CycleTimeTooltip } from './cycle-time-tooltip';
import { StaleValueContainer } from './cycle-time.style';

type CycleTimeCreatedColumnProps = {
  stale?: boolean;
  pullRequest: PullRequest;
  cycleTimeMetrics?: PrCycleMetrics;
};

export const CycleTimeCreatedColumn = (props: CycleTimeCreatedColumnProps) => {
  const { stale = false, pullRequest, cycleTimeMetrics } = props;

  const intl = useIntl();
  const createdText = intl.formatRelative(pullRequest.created_on, {
    style: 'numeric',
  });

  const createdTextCapitalized =
    createdText.charAt(0).toLocaleUpperCase() + createdText.slice(1);

  if (stale && cycleTimeMetrics) {
    return (
      <CycleTimeTooltip
        data-testid="cycle-time-tooltip"
        pullRequest={pullRequest}
        cycleTimeMetrics={cycleTimeMetrics}
      >
        <StaleValueContainer data-testid="cycle-time-created-text">
          <Text color="color.text.warning" weight="bold">
            {createdTextCapitalized}
          </Text>
        </StaleValueContainer>
      </CycleTimeTooltip>
    );
  }

  return <Text> {createdTextCapitalized} </Text>;
};
